import { render } from "./Plugins.vue?vue&type=template&id=9cfdd9d8"
import script from "./Plugins.vue?vue&type=script&lang=js"
export * from "./Plugins.vue?vue&type=script&lang=js"
script.render = render

export default script